import { render, staticRenderFns } from "./BtnSearch.vue?vue&type=template&id=a3bb7f54&scoped=true&"
import script from "./BtnSearch.vue?vue&type=script&lang=js&"
export * from "./BtnSearch.vue?vue&type=script&lang=js&"
import style0 from "./BtnSearch.vue?vue&type=style&index=0&id=a3bb7f54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3bb7f54",
  null
  
)

export default component.exports